import { Component, OnInit, Injector } from '@angular/core';
import { take } from 'rxjs';
import { ApplicationConstant } from '../../../../application.constant';
import { swErrorMessage } from '../../../../shared/constant/customer-journey/error-message-constant';
import { Gender } from '../../../../shared/enum/gender.enum';
import { Relationship } from '../../../../shared/enum/relationship.enum';
import { PersonType } from '../../../../shared/models/contract/person-type.model';
import { CommonService } from '../../../../shared/service/common.service';
import { Utils } from '../../../../shared/Utils/Utils';
import { BaseSWQuestion } from '../../../extended-class/base-ws-question';
import { DateOptionModel } from '../../../models/date-option.model';
import { LookUpResourceModel } from '../../../models/lookup-resource.model';
import { ValidDateOption } from '../../../models/valid-date-option.model';
import { SectionWiseValidationService } from '../../../service/section-wise-validation.service';
import { YesNo } from 'src/app/shared/enum/yesNo.enum';

@Component({
  selector: '[otherPolicyHolder]',
  templateUrl: './other-policy-holder.component.html'
})
export class OtherPolicyHolderComponent extends BaseSWQuestion implements OnInit {
  public question: LookUpResourceModel;
  public primaryPersonType: PersonType;
  public personTypes: PersonType[];
  public monthQuestion: LookUpResourceModel;
  public validDateOptions: ValidDateOption[];
  public numberOfInsurer = 0;
  private minDate: Date;
  private maxDate: Date;
  private isValid = true;
  private readonly dateFormat = 'dd/MM/yyyy';

  public get GenderEnum() {
    return Gender;
  }
  public get sWErrorMessage() {
    return swErrorMessage;
  }

  constructor(
    serviceInjector: Injector,
    private commonService: CommonService,
    private sectionWiseValidationService: SectionWiseValidationService
  ) {
    super(serviceInjector);
  }

  public ngOnInit() {
    this.validDateOptions = [];
    const currentDate = new Date();
    this.maxDate = new Date(currentDate);
    this.minDate = new Date(currentDate.setFullYear(currentDate.getFullYear() - 90));

    this.activatedRoute.queryParams.subscribe((param: any) => {
      this.question = JSON.parse(param['question']);
    });

    this.swProcessStateService.swContractType$.pipe(take(1)).subscribe((contractType) => {
      this.contractType = JSON.parse(JSON.stringify(contractType));
      this.personTypes = this.contractType.policyHolder.personType;
      this.numberOfInsurer = this.personTypes.length;
      this.personTypes.forEach((x) => {
        x.dateOption = Utils.getDateOption(x.birthDate);
        this.validDateOptions.push(new ValidDateOption());
      });
      this.primaryPersonType = this.personTypes.filter((x) => x.number === 1)[0];
    });

    this.mapQuestion();
  }

  public saveSectionAnswer() {
    this.isValid = true;

    this.personTypes.forEach((person, index) => {
      if (index === 0) {
        return;
      }

      if (!person.dateOption) {
        console.error('dateOption is null for the person on the index: ', index);
        return;
      }

      const validDateOption = this.sectionWiseValidationService.getValidDateOption(person.dateOption, this.minDate, this.maxDate);
      this.validDateOptions[index] = validDateOption;

      if (this.isValidModel(validDateOption)) {
        const selectedPersonDateOfBirth = new Date(person.dateOption.year, person.dateOption.month - 1, person.dateOption.day ?? 1);
        const dateOfBirthStringFormatted = this.commonService.customDateFormat(selectedPersonDateOfBirth, this.dateFormat);
        const dateOfBirthFormatted = this.commonService.formatDate(dateOfBirthStringFormatted);

        person.birthDate = dateOfBirthFormatted;
        person.birthAgeInYears = this.commonService.getAgeUsingDateOfBirth(dateOfBirthStringFormatted);
        person.gender = Gender.Hombre;
        person.insured = YesNo.Yes;
      } else {
        this.isValid = false;
      }
    });

    if (this.isValid) {
      this.addGTMAnswer(this.question.QuestionNumber, this.personTypes.map(m => m.birthAgeInYears).join('-'));
      this.swProcessStateService.updateSwProcessModel(this.contractType);
      this.sectionWiseService.closeSwqModal(this.question);
    } else {
      this.gtmDatalayerUiService.addVirtualPageValidationError('Q3', 2, 'Por favor, selecciona una fecha válida.').toPromise();
    }
  }

  public removeInsurer(index: number) {
    this.personTypes.splice(index, 1);
    this.personTypes.forEach((item, index1) => {
      item.number = index1 + 1;
    });

    this.validDateOptions.splice(index, 1);
    this.numberOfInsurer = this.personTypes.length;
  }

  public addNewInsurer() {
    const personType = new PersonType();
    personType.number = this.personTypes.length + 1;
    personType.dateOption.month = 0;
    personType.gender = Gender.Hombre;
    personType.relationshipWithPolicyHolder = Relationship.Other;
    this.personTypes.push(personType);

    this.validDateOptions.push(new ValidDateOption());

    this.numberOfInsurer = this.personTypes.length;
  }

  public addDeleteInsurer(numberOfInsurer: number) {
    if (this.personTypes.length > numberOfInsurer) {
      if (this.personTypes.length === 1) {
        this.numberOfInsurer = 1;
        return;
      }
      for (let i = this.personTypes.length - 1; i >= numberOfInsurer; i--) {
        this.removeInsurer(i);
      }
    } else {
      for (let i = this.personTypes.length; i < numberOfInsurer; i++) {
        this.addNewInsurer();
      }
    }
  }

  public numberOnly(evt: any) {
    return Utils.isNumber(evt);
  }

  public onDayKeyUp(dateOption: DateOptionModel) {
    // only allow value between 1 to 31
    if (dateOption.day == null || dateOption.day === 0) {
      dateOption.day = null;
      return;
    }
    if (dateOption.day > 31) {
      dateOption.day = parseInt((dateOption.day + '').charAt(0));
    }
  }

  private isValidModel(validDateOption: ValidDateOption) {
    if (!(validDateOption.isValidDate && validDateOption.isValidDay && validDateOption.isValidMonth && validDateOption.isValidYear)) {
      this.isValid = false;
    }
    return this.isValid;
  }

  private mapQuestion() {
    const result = ApplicationConstant.lookupResourceDetails.find((x) => x.QuestionKey === 'Question_BirthDate_Health_NoOfPolicyHolder');

    if (!result) {
      console.error('Resource not found for the provided QuestionKey: Question_BirthDate_Health_NoOfPolicyHolder');
      return;
    }

    this.monthQuestion = result;
  }
}
